const PersistenceConfig = require('utils/persistence-config');

const AUTH_STORAGE_NAMESPACE = PersistenceConfig.createKey('auth');
const createAuthKey = (...segments) => PersistenceConfig.createKey('auth', ...segments);

const keys = Object.freeze({
    persistentVersion: createAuthKey('persistence', 'local-version'),
    sessionVersion: createAuthKey('persistence', 'session-version'),
    token: createAuthKey('token'),
    continuation: createAuthKey('continuation'),
    termsAgreement: createAuthKey('signup', 'terms-agreed'),
    loginContext: createAuthKey('login', 'context'),
    signupContext: createAuthKey('signup', 'context'),
    loginMfaContext: createAuthKey('login', 'mfa-context'),
    signupMfaContext: createAuthKey('signup', 'mfa-context'),
    debug: createAuthKey('debug', 'enabled'),
    debugFlows: createAuthKey('debug', 'flows'),
    debugErrors: createAuthKey('debug', 'errors'),
    debugApi: createAuthKey('debug', 'api'),
    sso: Object.freeze({
        runtimeDebug: createAuthKey('sso', 'runtime-debug'),
        callbackContext: createAuthKey('sso', 'callback-context'),
        lastSuccessfulEmail: createAuthKey('sso', 'last-successful-email'),
        auth0: Object.freeze({
            state: createAuthKey('sso', 'auth0', 'state'),
            nonce: createAuthKey('sso', 'auth0', 'nonce'),
            redirectUri: createAuthKey('sso', 'auth0', 'redirect-uri'),
            tokenResponse: createAuthKey('sso', 'auth0', 'token-response')
        }),
        keycloak: Object.freeze({
            state: createAuthKey('sso', 'keycloak', 'state'),
            nonce: createAuthKey('sso', 'keycloak', 'nonce'),
            redirectUri: createAuthKey('sso', 'keycloak', 'redirect-uri'),
            tokenResponse: createAuthKey('sso', 'keycloak', 'token-response')
        })
    })
});

const legacyKeys = Object.freeze({
    version: 'nearpeer:auth:storage-version',
    token: 'token',
    loginContext: 'login-context',
    signupContext: 'signup-context',
    termsAgreement: 'nearpeer:signup-terms-agreed',
    loginMfaContext: 'nearpeer:login-mfa-context',
    signupMfaContext: 'nearpeer:signup-mfa-context',
    debug: 'nearpeer:auth-management:debug',
    debugFlows: 'nearpeer:auth-management:flows',
    debugErrors: 'nearpeer:auth-management:errors',
    debugApi: 'nearpeer:auth-management:api',
    sso: Object.freeze({
        runtimeDebug: 'nearpeer_sso_runtime_debug',
        callbackContext: 'nearpeer_sso_callback_context',
        lastSuccessfulEmail: 'nearpeer:last-successful-sso-email',
        auth0: Object.freeze({
            state: 'nearpeer_auth0_sso_state',
            nonce: 'nearpeer_auth0_sso_nonce',
            redirectUri: 'nearpeer_auth0_sso_redirect_uri',
            tokenResponse: 'nearpeer_auth0_sso_token_response'
        }),
        keycloak: Object.freeze({
            state: 'nearpeer_sso_state',
            nonce: 'nearpeer_sso_nonce',
            redirectUri: 'nearpeer_sso_redirect_uri',
            tokenResponse: 'nearpeer_sso_token_response'
        })
    })
});

module.exports = Object.freeze({
    namespace: AUTH_STORAGE_NAMESPACE,
    currentVersion: 2,
    keys,
    legacyKeys
});
